var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ask-24-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5001 3.54166C64.0162 3.54166 81.4584 20.9839 81.4584 42.5C81.4584 48.9886 79.8672 55.2524 76.8771 60.8444L76.6028 61.331L76.7728 61.03L77.9035 74.0694L78.2646 78.2379L74.0937 77.9055L60.8813 76.8506L60.689 76.9597C55.5323 79.6871 49.8115 81.2282 43.874 81.4345L42.5001 81.4583C20.984 81.4583 3.54175 64.0161 3.54175 42.5C3.54175 20.9839 20.984 3.54166 42.5001 3.54166ZM42.5001 10.625C24.896 10.625 10.6251 24.8959 10.6251 42.5C10.6251 60.1041 24.896 74.375 42.5001 74.375C48.1415 74.375 53.5612 72.9106 58.3425 70.1661L59.2937 69.6201L60.387 69.7073L70.4828 70.511L69.6236 60.5599L69.527 59.4445L70.089 58.4763C72.8829 53.6631 74.3751 48.1947 74.3751 42.5C74.3751 24.8959 60.1042 10.625 42.5001 10.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.dccf3070722037f5001ec42d6a681d70.svg";
export { ForwardRef as ReactComponent };